module.exports = __webpack_public_path__ + "static/img/i-park4.5c146ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/i-park4.jpg
// module id = wklr
// module chunks = 1